import { Directive } from '@angular/core';
export class BoxSmallFooterDirective {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: 'mk-box-small-footer'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function BoxSmallFooterDirective_tsickle_Closure_declarations() {
/** @type {?} */
BoxSmallFooterDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
BoxSmallFooterDirective.ctorParameters;
}

export class BoxSmallHeaderDirective {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: 'mk-box-small-header'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function BoxSmallHeaderDirective_tsickle_Closure_declarations() {
/** @type {?} */
BoxSmallHeaderDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
BoxSmallHeaderDirective.ctorParameters;
}

export class BoxSmallContentDirective {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: 'mk-box-small-content'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function BoxSmallContentDirective_tsickle_Closure_declarations() {
/** @type {?} */
BoxSmallContentDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
BoxSmallContentDirective.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
